import { render, staticRenderFns } from "./TheDashboard.vue?vue&type=template&id=0bf7ef46&scoped=true&"
import script from "./TheDashboard.vue?vue&type=script&lang=js&"
export * from "./TheDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TheDashboard.vue?vue&type=style&index=0&id=0bf7ef46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf7ef46",
  null
  
)

export default component.exports